import { Link } from 'react-router-dom';
import { IBioSecurity } from '../../entities/task.entities';
import { useSelector } from 'react-redux';
import { translate } from '../../lib/lang.helper';
import { selectLang } from '../../store/ui/ui.selector';
import { FarmDiv, LineDiv } from './CalendarCell';

interface Props {
  bioData: IBioSecurity;
  onShowBioSecurity: (d: IBioSecurity) => void;
}

const WaterQualityCell = ({ bioData, onShowBioSecurity }: Props) => {
  const lang = useSelector(selectLang);

  const handleClick = (event: any) => {
    event.preventDefault();
    onShowBioSecurity(bioData);
  };

  return (
    <div className='--entity --water_quality' onClick={handleClick}>
      <div className='--header'>
        <span>{translate(lang, 'Water Quality')}</span>
      </div>
      <div className='--title'>
        {bioData.user && (
          <div className='mt-7'>{`by ${bioData.user.name}`}</div>
        )}
        <div className='d-flex flex-wrap gap-7'>
          <FarmDiv farm={bioData.farm} />
          <LineDiv line={bioData.line} />
        </div>
      </div>
      <div className='--btn-bar'>
        <Link
          to={`/farms/${bioData.farm.id}/${bioData.line.id}`}
          className='--view'
        >
          {translate(lang, 'View')}
        </Link>
      </div>
    </div>
  );
};

export default WaterQualityCell;
